export enum TypesProfile {
  ADMIN = "admin",
  ADMIN_PORTAL_CLIENTE = "admin_portal_cliente",
  PORTAL_CLIENTE = "portal_cliente",
}
